import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
     Home, FileText, CalendarCheck, ClipboardList, Folder,
     ChevronRight, Users, Clock,
     MapPin, Building2, Layers, Briefcase, Award, UserCheck, BookOpen
} from 'lucide-react';

const mastersMenu = [
     { name: 'Doctors Shift Master', path: '/doctors-shift-master', icon: <Folder size={18} style={{ marginRight: 8 }} /> },
     { name: 'Employee Shift Master', path: '/employee-shift-master', icon: <Folder size={18} style={{ marginRight: 8 }} /> },
     { name: 'SBU', path: '/sbu', icon: <Folder size={18} style={{ marginRight: 8 }} /> },
     { name: 'PayGroup', path: '/paygroup', icon: <Folder size={18} style={{ marginRight: 8 }} /> },
     { name: 'Region', path: '/region', icon: <MapPin size={18} style={{ marginRight: 8 }} /> },
     { name: 'City', path: '/city', icon: <Building2 size={18} style={{ marginRight: 8 }} /> },
     { name: 'Cluster', path: '/cluster', icon: <Layers size={18} style={{ marginRight: 8 }} /> },
     { name: 'Dept Category', path: '/deptcategory', icon: <Folder size={18} style={{ marginRight: 8 }} /> },
     { name: 'Main Dept', path: '/maindept', icon: <Folder size={18} style={{ marginRight: 8 }} /> },
     { name: 'Sub Dept', path: '/subdept', icon: <Folder size={18} style={{ marginRight: 8 }} /> },
     { name: 'Designation', path: '/designation', icon: <Briefcase size={18} style={{ marginRight: 8 }} /> },
     { name: 'Grade', path: '/grade', icon: <Award size={18} style={{ marginRight: 8 }} /> },
     { name: 'Position', path: '/position', icon: <UserCheck size={18} style={{ marginRight: 8 }} /> },
     { name: 'Religion', path: '/religion', icon: <BookOpen size={18} style={{ marginRight: 8 }} /> },
     { name: 'Caste', path: '/caste', icon: <BookOpen size={18} style={{ marginRight: 8 }} /> },
     { name: 'Degrees', path: '/degrees', icon: <Award size={18} style={{ marginRight: 8 }} /> },
     { name: 'Location', path: '/location', icon: <MapPin size={18} style={{ marginRight: 8 }} /> },
     { name: 'Blood Group', path: '/bloodgroup', icon: <Award size={18} style={{ marginRight: 8 }} /> },
];

const HrbpNav = ({ isHovered, styles, onToggle, mastersOpen = false, setMastersOpen = () => { } }) => {
     const [adminOpen, setAdminOpen] = useState(false);
     const [attendanceSummeryOpen, setAttendanceSummaryOpen] = useState(false);
     return (
          <>
               <NavLink to="/dashboard" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Home size={20} />
                    {isHovered && <span>Dashboard</span>}
               </NavLink>
               <NavLink to="/employee-master" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Users size={20} />
                    {isHovered && <span>Employees</span>}
               </NavLink>
               <NavLink to="/employee-attendance" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <CalendarCheck size={20} />
                    {isHovered && <span>Employee Attendance</span>}
               </NavLink>
               {/* regularize */}
               {/* <NavLink to="/regularize" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <ClipboardList size={20} />
                    {isHovered && <span>Regularize Requests</span>}
               </NavLink> */}
               {/* Admin Dropdown */}
               <div>
                    <button
                         type="button"
                         style={{
                              ...styles.navItem,
                              background: 'none',
                              border: 'none',
                              width: '100%',
                              textAlign: 'left',
                              display: 'flex',
                              alignItems: 'center',
                              cursor: 'pointer',
                              padding: '8px 12px',
                              color: '#333',
                         }}
                         onClick={() => setAdminOpen(!adminOpen)}
                    >
                         <CalendarCheck size={20} />
                         {isHovered && (
                              <>
                                   <span style={{ fontSize: 14 }}>Duty Roster</span>
                                   <ChevronRight
                                        size={18}
                                        style={{
                                             marginLeft: 'auto',
                                             transition: 'transform 0.2s',
                                             transform: adminOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                        }}
                                   />
                              </>
                         )}
                    </button>
                    {adminOpen && isHovered && (
                         <div style={{ paddingLeft: 32 }}>
                              <NavLink
                                   to="/dutyroster"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <Folder size={16} />
                                   <span style={{ marginLeft: 8 }}>Duty Roster</span>
                              </NavLink>
                              <NavLink
                                   to="/dutyrosterbulk"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <Folder size={16} />
                                   <span style={{ marginLeft: 8 }}>Duty Roster Bulk</span>
                              </NavLink>
                              <NavLink
                                   to="/split-duty-roster"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: '14px',
                                        padding: '6px 12px',
                                   })}
                              >
                                   <ClipboardList size={16} />
                                   <span style={{ marginLeft: '8px' }}>Split Duty Roster</span>
                              </NavLink>
                         </div>
                    )}
               </div>

               {/* Attendance Summary Dropdown */}
               <div>
                    <button
                         type="button"
                         style={{
                              ...styles.navItem,
                              background: 'none',
                              border: 'none',
                              width: '100%',
                              textAlign: 'left',
                              display: 'flex',
                              alignItems: 'center',
                              cursor: 'pointer',
                              padding: '8px 12px',
                              color: '#333',
                         }}
                         onClick={() => setAttendanceSummaryOpen(!attendanceSummeryOpen)}
                    >
                         <CalendarCheck size={20} />
                         {isHovered && (
                              <>
                                   <span style={{ fontSize: 14 }}>Attendance Summary</span>
                                   <ChevronRight
                                        size={18}
                                        style={{
                                             marginLeft: 'auto',
                                             transition: 'transform 0.2s',
                                             transform: attendanceSummeryOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                        }}
                                   />
                              </>
                         )}
                    </button>
                    {attendanceSummeryOpen && isHovered && (
                         <div style={{ paddingLeft: 32 }}>
                              <NavLink
                                   to="/doctor-attendance-summary"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <Folder size={16} />
                                   <span style={{ marginLeft: 8 }}>Doctor Summary</span>
                              </NavLink>
                              <NavLink
                                   to="/employee-attendance-summary"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <Folder size={16} />
                                   <span style={{ marginLeft: 8 }}>Employee Summary</span>
                              </NavLink>
                              <NavLink
                                   to="/poojari-attendance-summary"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <ClipboardList size={16} />
                                   <span style={{ marginLeft: 8 }}>Poojari Summary</span>
                              </NavLink>
                         </div>
                    )}
               </div>
               {/* /citywise-on-duty-doctors */}
               <NavLink to="/citywise-on-duty-doctors" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Users size={20} />
                    {isHovered && <span>Doctors On Duty</span>}
               </NavLink>
               <NavLink to="/hr-radiology-assessment" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <ClipboardList size={20} />
                    {isHovered && <span>Radiology Assessment - HR</span>}
               </NavLink>

               {/* <NavLink to="/leave-management" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <FileText size={20} />
                    {isHovered && <span>Doctors Leaves</span>}
               </NavLink>
               <NavLink to="/leaves/requests" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Clock size={20} />
                    {isHovered && <span>Leave Applications</span>}
               </NavLink> */}

               {/* Masters Dropdown */}
               <div>
                    <button
                         type="button"
                         style={{
                              ...styles.navItem,
                              background: 'none',
                              border: 'none',
                              width: '100%',
                              textAlign: 'left',
                              display: 'flex',
                              alignItems: 'center',
                              cursor: 'pointer',
                              color: '#333',
                         }}
                         onClick={() => setMastersOpen(!mastersOpen)}
                    >
                         <Folder size={20} />
                         {isHovered && (
                              <>
                                   <span style={{ fontSize: 14 }}>Masters</span>
                                   <ChevronRight
                                        size={18}
                                        style={{
                                             marginLeft: 'auto',
                                             transition: 'transform 0.2s',
                                             transform: mastersOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                        }}
                                   />
                              </>
                         )}
                    </button>
                    {mastersOpen && isHovered && (
                         <div style={{ paddingLeft: '2px' }}>
                              {mastersMenu.map((item, idx) => (
                                   <NavLink
                                        key={idx}
                                        to={item.path}
                                        style={({ isActive }) => ({
                                             ...styles.navItem,
                                             ...(isActive ? styles.navItemActive : {}),
                                             fontSize: '14px',
                                        })}
                                   >
                                        {item.icon}
                                        <span>{item.name}</span>
                                   </NavLink>
                              ))}
                         </div>
                    )}
               </div>
          </>
     );
};

export const hrBPNav = (isHovered, styles, onToggle, setMastersOpen, mastersOpen) => {
     return <HrbpNav isHovered={isHovered} styles={styles} onToggle={onToggle} setMastersOpen={setMastersOpen} mastersOpen={mastersOpen} />;
}

export default HrbpNav;